import { Trans } from "@lingui/macro";
import Image from "next/image";
import React from "react";

// export interface NewArrivalBadgeProps {}

const NewArrivalBadge = () => {
	return (
		<div className="flex flex-row rounded-lg overflow-hidden">
			{/* <div
				className="hidden sm:flex px-2 items-center"
				style={{ background: "rgba(0, 0, 0, 0.54)" }}
			>
				<Image src="/icons/airBalloon.svg" alt="" width={16} height={16} />
			</div> */}
			<div className="bg-red-500 text-white px-2 py-3 font-semibold text-xs m-auto uppercase">
				<Trans>New</Trans>
			</div>
		</div>
	);
};

export default NewArrivalBadge;
